import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageRowDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    MESSAGE_DIRECTIONS
} from "../../stylesheet";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        width: "100%",
        minWidth: 0
    }
});

export const useStyles = ({
    isSystem,
    isPlain,
    spaces,
    align
}: MessageRowDynamicStyleType) => {
    const styles = {
        container: {
            flexDirection: isPlain ? "column" : MESSAGE_DIRECTIONS[align],
            justifyContent: isSystem ? "center" : "flex-start",
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
